export default __webpack_public_path__ + "static/media/img_baseBunny_grey_p.377ec52e.jpg";